import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {CommentModel, CustomFormTypes, CustomPaymentInformationModel, InformationStatus} from './end-user-order-custom-payment.model';
import {
  generalExtendedStatus
} from '../../../../end-user-order/end-user-order-list/end-user-order-view/end-user-order-debt-log/end-user-order-penalty-debt.model';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {BehaviorSubject, Subscriber} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {EndUserCreditCard} from '../../../../end-user/models/end-user.model';
import {environment} from '../../../../../environments/environment';
import {NotificationsService} from 'angular2-notifications';
import {AcquirerType} from '../../../../project/project-country/acquirer/acquirer-type';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-end-user-order-payment-item',
  templateUrl: './end-user-order-payment-item.component.html',
})
export class EndUserOrderPaymentItemComponent implements OnChanges {
  public readonly CustomFormTypes = CustomFormTypes;
  @Input() model: CustomPaymentInformationModel;
  @Output() submitFormCancelEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() submitFormPayEvent: EventEmitter<number> = new EventEmitter<number>();

  @Input() set subscriberEvent(event: Subscriber<any>) {
    this.stateRequest = event;
  }

  @Input() set closeFormEvent(event: boolean) {
    if (event) {
      this.closeForm();
      this.model.status = null;
    }
  }

  endUserCards: BehaviorSubject<Array<EndUserCreditCard>> = new BehaviorSubject<Array<EndUserCreditCard>>([]);
  selectedCard: EndUserCreditCard | null = null;
  comments: Array<CommentModel> = [];
  activeFormType: CustomFormTypes = null;
  stateRequest = null;
  activeCardId: number | null = null;
  formControlForCancel = new FormGroup({
    description: new FormControl('', [Validators.required])
  });


  constructor(
    protected http: HttpClient,
    protected notificationsService: NotificationsService,
    protected translateService: TranslateService,
  ) {
  }

  activeForm(type: CustomFormTypes.Canceled | CustomFormTypes.Pay) {
    return this.activeFormType === type;
  }

  isStatusCanceled(status: InformationStatus) {
    return status === generalExtendedStatus.Canceled;
  }

  isStatusNotPaid(status: InformationStatus) {
    return status === generalExtendedStatus.NotPaid;
  }

  isStatusPaid(status: InformationStatus) {
    return status === generalExtendedStatus.Paid;
  }

  clickCancelBtn() {
    this.closeForm();
    this.activeFormType = CustomFormTypes.Canceled;
  }

  clickPayBtn() {
    this.closeForm();
    this.activeFormType = CustomFormTypes.Pay;
    this.getCards();
  }

  chosenCardIdEvent(chosenCardId: number | null) {
    this.activeCardId = chosenCardId;
    this.selectedCard = this.endUserCards.getValue().find(c => c.id === chosenCardId);
  }

  getCards() {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('expand', 'acquirerName,acquirerTypeName');
    return this.http.get<Array<EndUserCreditCard>>(
      environment.apiBasepoint + this.model.getCardsUrl,
      {
        params: httpParams,
        observe: 'body'
      }
    ).subscribe(result => {
      this.endUserCards.next(result);
    });
  }

  closeForm() {
    this.activeFormType = null;
    this.activeCardId = null;
    this.formControlForCancel.reset();
    this.endUserCards.next(null);
  }

  submitForm() {
    switch (this.activeFormType) {
      case CustomFormTypes.Pay:
        if (this.selectedCard && this.selectedCard.acquirerTypeName === AcquirerType.PAYMENT_SYSTEM_PAYANYWAY) {
          this.notificationsService.error(
            this.translateService.instant('Error'),
            this.translateService.instant('This function is disabled for Moneta acquirer')
          );
          break;
        }
        this.submitFormPayEvent.emit(this.activeCardId);
        break;
      case CustomFormTypes.Canceled:
        this.submitFormCancelEvent.emit(this.formControlForCancel.get('description').value);
        break;
    }
  }

  btnIsDisabled() {
    return this.stateRequest
      || (this.activeForm(CustomFormTypes.Canceled) && !this.formControlForCancel.valid)
      || (this.activeForm(CustomFormTypes.Pay) && this.activeCardId == null);
  }

  ngOnChanges() {
    this.comments = this.model.comments.filter(comment => comment.description || comment.initiator || comment.timestamp);
    if (this.model.status !== generalExtendedStatus.NotPaid) {
      this.closeForm();
    }
  }
}
